$.extend({
  isNotEmpty: function isNotEmpty(obj) {
    return !$.isEmpty(obj);
  },
  isEmpty: function isEmpty(obj) {
    if (obj == "undefined") {
      return true;
    } else if (obj == null) {
      return true;
    } else if (obj === "") {
      return true;
    } else if (obj === "null") {
      return true;
    } else {
      return false;
    }
  },
  getFileActionPath:function(filePath,fileName){
    fileName += filePath.substr(filePath.lastIndexOf("."),filePath.length-1);//加后缀
    return fileAction.replace("{filePath}",filePath).replace("{fileName}",fileName);
  },
  submitFormPost:function(url,data){
    let input = '';
    if(data){
      $.each(data, function (i, o) {
        input += "<input type='hidden' name='"+i+"' value='"+o+"'/>"
      });
    }
    let token = localStorage.getItem("qc_token");
    $('<form method="post" action="' + url + '"><input type="hidden" value="'+token+'" name="_header"/>'+input+'</form>').appendTo('body').submit().remove();
  },
  submitFormPost2:function(url,ids){
    let token = localStorage.getItem("qc_token");
    $('<form method="post" action="' + url + '"><input type="hidden" value="\'+token+\'" name="_header"/><input name="ids" value="'+ids+'"/></form>').appendTo('body').submit().remove();
  },
  handleUrl: function handleUrl(url) {
    return baseURL + url + _EXT;
  },
  formatLabelData: function formatLabelData(data, format) {
    return $.formatType(data, format, 'label');
  },
  formatValueData: function formatValueData(data, format) {
    return $.formatType(data, format, 'value');
  },
  formatType: function formatType(data, format, type) {
    var splits = format.split(",");
    $.each(data, function (i, o) {
      var re = "";
      $.each(splits, function (index, s) {
        re += o[s] + "/";
        if ($.isNotEmpty(re) && index === splits.length - 1) {
          re = re.substring(0, re.length - 1);
        }
      });
      o[type] = re;
    });
    return data;
  },
  getUrlFileName: function getUrlFileName(s) {
    s = s.replace(/\?.*$/, '');
    s = s.replace(/^.*\//, '');
    return s.split(".")[0];
  },
  getNowDate: function getNowDate() {
    var date = new Date();
    return date.getFullYear() + "-" + (date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "-" + (date.getDate() > 9 ? date.getDate() : "0" + date.getDate());
  },
  getNowDateTime: function getNowDateTime() {
    var date = new Date();
    return date.getFullYear() + "-" + (date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + date.getMonth() + 1) + "-" + (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + " " + (date.getHours() > 9 ? date.getHours() : "0" + date.getHours()) + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes()) + ":" + (date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds());
  },
  md5Code: function md5Code(param) {
    return "?code=" + btoa(encodeURIComponent(param));
  },
  checkPic:function checkPic(obj, fileSize) {
    var picExts = 'jpg|jpeg|png|bmp|gif|webp';
    var photoExt = obj.value.substr(obj.value.lastIndexOf(".") + 1).toLowerCase(); //获得文件后缀名
    var pos = picExts.indexOf(photoExt);
    if (pos < 0) {
      this.messageError("您选中的文件不是图片，请重新选择");
      return false;
    }
    fileSize = Math.round(fileSize / 1024 * 100) / 100; //单位为KB
    if (fileSize > 30 * 1024) {
      this.messageError("您选择的图片大小超过限制(最大为30M)，请重新选择");
      return false;
    }
    return true;
  },
  checkFile:function checkFile(file) {
    let fileSize = Math.round(file.size / 1024 * 100) / 100; //单位为KB
    if (fileSize > 20 * 1024) {
      alert("您选择的文件大小超过限制(最大为20M)，请重新选择");
      return false;
    }
    return true;
  }
});

String.prototype.contains = function (str) {
  return this.indexOf(str) != -1;
};

/**
 * 数组删除指定对象
 * @param val
 */
Array.prototype.remove = function (val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};
Array.prototype.contains = function (obj) {
  var i = this.length;
  while (i--) {
    if (this[i] === obj) {
      return true;
    }
  }
  return false;
}
Array.prototype.pushAll = function(resouce){
  var arr = this;
  $.each(resouce,(i,item)=>{
    arr.push(item);
  });
};


/**
 * 正则表单验证
 */
//手机号码验证：匹配130-139 150-159(除去154号段) 147 170 171 176-178 180-189号段
var mobilePass = /^\d{11}$/;
//验证邮箱
var emailPass = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

//验证QQ
var QQPass = /^[1-9][0-9]{4,10}$/gim;

//客服号码验证：匹配电话号码、手机号码
var serviceMobile = (rule, value, callback)  => {
  if (value === '') {
    callback(new Error('请输入客服电话'));
  } else {
    var reg1 = /^1(3[0-9]|47|5((?!4)[0-9])|7(0|1|[6-8])|8[0-9])\d{8,8}$/;
    var reg2 = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;

    console.log(reg1.test(value));
    console.log(reg2.test(value));
    if (reg1.test(value) ||  reg2.test(value)) {
      callback();
    } else {
      callback(new Error('请输入正确的客服电话'));
    }
  }
};
//域名验证
var demainVal = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入域名'));
  } else {
    let reg = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;
    if (!reg.test(value)) {
      callback(new Error('请输入正确域名'));
    }
    callback();
  }
};

//验证身份证
var idPass = function idPass(rule, value, callback) {
  if (value === '') {
    callback();
  } else {
    var reg = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
    if (reg.test(value) && checkIdPass(value) || value.length == 15 && isValidityBrithBy15IdCard(value)) {
      callback();
    } else {
      callback(new Error('请输入正确的身份证'));
    }
  }
};
var idPassMust = function idPassMust(rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入身份证'));
  } else {
    idPass(rule, value, callback);
  }
};

function checkIdPass(value) {
  var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; // 加权因子
  var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2]; // 校验码
  var sum = 0,
    idx;
  for (var i = 0; i < value.length - 1; i++) {
    // 对前17位数字与权值乘积求和
    sum += parseInt(value.substr(i, 1), 10) * arrExp[i];
  }
  // 计算模（固定算法）
  idx = sum % 11;
  return arrValid[idx] == value.substr(17, 1).toUpperCase();
}
function isValidityBrithBy15IdCard(idCard15) {
  var year = idCard15.substring(6, 8);
  var month = idCard15.substring(8, 10);
  var day = idCard15.substring(10, 12);
  var temp_date = new Date(year, parseFloat(month) - 1, parseFloat(day));
  // 对于老身份证中的你年龄则不需考虑千年虫问题而使用getYear()方法
  if (temp_date.getYear() != parseFloat(year) || temp_date.getMonth() != parseFloat(month) - 1 || temp_date.getDate() != parseFloat(day)) {
    return false;
  } else {
    return true;
  }
}
function clearup() {
  window.clipboardData.setData("text", "");
}

function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1, //month
    "d+": this.getDate(),    //day
    "h+": this.getHours(),   //hour
    "m+": this.getMinutes(), //minute
    "s+": this.getSeconds(), //second
    "q+": Math.floor((this.getMonth() + 3) / 3),  //quarter
    "S": this.getMilliseconds() //millisecond
  }
  if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
    (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o) if (new RegExp("(" + k + ")").test(format))
    format = format.replace(RegExp.$1,
      RegExp.$1.length == 1 ? o[k] :
        ("00" + o[k]).substr(("" + o[k]).length));
  return format;
}
